var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProcessed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 3.83334H6.25C5.91848 3.83334 5.60054 3.96504 5.36612 4.19946C5.1317 4.43388 5 4.75182 5 5.08334V15.0833C5 15.4149 5.1317 15.7328 5.36612 15.9672C5.60054 16.2016 5.91848 16.3333 6.25 16.3333H13.75C14.0815 16.3333 14.3995 16.2016 14.6339 15.9672C14.8683 15.7328 15 15.4149 15 15.0833V8.20834L10.625 3.83334Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3669 10.6895L17.7314 11.0318L17.3669 10.6895L14.275 13.982L13.6315 13.2219C13.1835 12.6929 12.3643 12.7032 11.9297 13.2433C11.5925 13.6625 11.6068 14.2639 11.9636 14.6666L13.0135 15.8518C13.6747 16.5981 14.8332 16.6178 15.5193 15.8945L18.9972 12.2283C19.3771 11.8278 19.4089 11.2102 19.072 10.7729L18.6759 11.078L19.072 10.7729C18.6507 10.2258 17.8396 10.1861 17.3669 10.6895Z",
    fill: "currentColor",
    stroke: "#E9F8F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 3.83334V8.83334H14.9999",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProcessed);
export default __webpack_public_path__ + "static/media/icon-processed.5b123238fa78aec62b53dbc65fa9881e.svg";
export { ForwardRef as ReactComponent };